<!-- components/ChatWaitingBar.vue -->
<template>
  <div class="px-4 py-3 mb-4">
    <div class="bg-orange-50 border border-orange-200 rounded-lg p-3">
      <div class="flex items-center space-x-3">
        <!-- Animated pulse icon -->
        <div class="flex space-x-1">
          <div class="w-2 h-2 bg-orange-400 rounded-full animate-pulse"></div>
          <div class="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style="animation-delay: 0.2s;"></div>
          <div class="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style="animation-delay: 0.4s;"></div>
        </div>
        
        <!-- Text -->
        <div>
          <p class="text-orange-700 text-sm font-medium">
            Warten auf Support...
          </p>
          <p class="text-orange-600 text-xs">
           Ein Teammitglied wird gleich dem Chat beitreten.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatWaitingBar'
}
</script>